import axiosInstance from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse } from '@/types'
import store from '@/store'
import { AxiosResponse } from 'axios'
import metaActions from '@/store/metaModule/actionTypes'

export const fetchCountries = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await axiosInstance().get('/data/countries')
    setUserLocation(response)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const fetchRegions = async (
  countryCode: string | null = null
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await axiosInstance().get('/data/regions', {
      params: { countryCode },
    })
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}

export const fetchMajors = async (queryString = ''): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await axiosInstance().get('/v4/majors', {
      params: { major: queryString },
    })
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}

const setUserLocation = (response: AxiosResponse) => {
  const countryCode = response.headers['x-user-country']
  if (!countryCode) return
  store.dispatch(metaActions.SET_CLIENT_COUNTRY.NAMESPACED, countryCode)
}
